// Countdown helpers for the Raven matrix. The server deadline is the clock.
export function remainingMs(now, deadlineMs) {
  return deadlineMs - now
}

export function activeWarnings(remaining, thresholds) {
  if (remaining <= 0) return []
  return thresholds.filter((ms) => remaining <= ms)
}

export function shouldAutoSubmit(remaining) {
  return remaining <= 0
}
